import { useMemo } from 'react';
import { validateDateRange } from './dateRange.validation';
import { DateRangeConstraints } from './dateRange.types';
import { splitAndOrderDateRangeIssues } from './dateRange.priorities';


export function useDateRangeValidation(
  start: Date | null,
  end: Date | null,
  constraints?: DateRangeConstraints
) {
  return useMemo(() => {
    const issues = validateDateRange(start, end, constraints);

    const {
      ordered,
      errors,
      warnings,
      primary,
    } = splitAndOrderDateRangeIssues(issues);

    return {
      issues: ordered,
      errors,
      warnings,
      primary,
      hasErrors: errors.length > 0,
      hasWarnings: warnings.length > 0,
    };
  }, [start, end, constraints]);
}
